/**
 * EmployerRoleDetailPage.jsx — Employer v1.1 Phase 0.6 Slice A
 * thin page wrapper for the read-only role detail surface.
 *
 * /employer/roles/:id route binding. Legacy editor surface moves
 * to /employer/roles/:id/edit (binding done in App.js).
 */
import RoleDetailPage from '@/components/employer/roles/RoleDetailPage';

export default function EmployerRoleDetailPage() {
  return <RoleDetailPage />;
}
